export default "__VITE_ASSET__CDfQzGG2__"